import { Controller } from "@hotwired/stimulus"

// Figures count up from zero when they appear (the dashboard, and each change of period).
// The server renders the final value: without JavaScript, or with reduced motion, it just shows.
export default class extends Controller {
  static targets = ["number"]

  declare readonly numberTargets: HTMLElement[]

  connect() {
    if (matchMedia("(prefers-reduced-motion: reduce)").matches) return

    const format = new Intl.NumberFormat("fr-FR")
    const ease = (t: number) => 1 - Math.pow(1 - t, 4)
    const duration = 1100
    const figures = this.numberTargets.map(element => {
      const value = Number(element.textContent?.replace(/\D/g, "") || 0)
      element.textContent = format.format(0)
      return { element, value }
    })

    const start = performance.now()
    const frame = (now: number) => {
      const t = Math.min(1, (now - start) / duration)
      figures.forEach(({ element, value }) => { element.textContent = format.format(Math.round(value * ease(t))) })
      if (t < 1) requestAnimationFrame(frame)
    }
    requestAnimationFrame(frame)
  }
}
